import type { Provider } from '@angular/core';
import { provideTranslocoScope } from '@jsverse/transloco';
import { i18nLoader } from './i18n-loader';

/**
 * Provides the transloco scope for the Notification domain.
 *
 * Scope Details:
 * - Scope: 'notification' (used in templates: t['notification:key'])
 * - Translations: Located in i18n/[language].json files
 */
export function provideTranslocoScopeNotification(): Provider {
  return provideTranslocoScope({ scope: 'notification', loader: i18nLoader });
}
